module.exports = __webpack_public_path__ + "static/media/contact-us-icon.5f595efb.svg";